import { render, staticRenderFns } from "./EditContentCategoryComponent.vue?vue&type=template&id=6e00a999&scoped=true"
import script from "./EditContentCategoryComponent.vue?vue&type=script&lang=js"
export * from "./EditContentCategoryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e00a999",
  null
  
)

export default component.exports